<div class="logs-table-container">
  <p-table
    [value]="logs"
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 20, 50]"
    [responsive]="true"
    styleClass="p-datatable-striped"
    [tableStyle]="{'min-width': '50rem'}">

    <ng-template pTemplate="header">
      <tr>
        <th style="width: 50px"></th>
        <th>Data/Hora</th>
        <th>Usuário</th>
        <th>Alterações</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-log>
      <tr>
        <td>
          <button
            type="button"
            pButton
            pRipple
            [icon]="expandedRows[log.id] ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
            class="p-button-text p-button-rounded p-button-plain expand-button"
            (click)="toggleRow(log)">
          </button>
        </td>
        <td>{{ formatDate(log.changedAt) }}</td>
        <td>
          <div class="user-info">
            <i class="pi pi-user"></i>
            <span>{{ log.userName || 'N/A' }}</span>
          </div>
        </td>
        <td>
          <span class="badge badge-info">{{ getChangeCount(log.changes) }} campo(s)</span>
        </td>
      </tr>
      <tr *ngIf="expandedRows[log.id]" class="expansion-row">
        <td colspan="4">
          <div class="changes-detail">
            <div class="changes-header">
              <h4>
                <i class="pi pi-list"></i>
                Detalhes das Alterações
              </h4>
              <span class="change-count">{{ getChangeCount(log.changes) }} alteração(ões)</span>
            </div>

            <div class="changes-list" *ngIf="log.changes && log.changes.length > 0">
              <div class="change-item" *ngFor="let change of log.changes">
                <div class="change-field-name">
                  <i class="pi pi-tag"></i>
                  <strong>{{ translateFieldName(change.fieldName) }}</strong>
                </div>
                <div class="change-values">
                  <div class="value-before">
                    <span class="value-label">Antes:</span>
                    <span class="value-content" [innerHTML]="formatValue(change.valueBefore)"></span>
                  </div>
                  <div class="value-arrow">
                    <i class="pi pi-arrow-right"></i>
                  </div>
                  <div class="value-after">
                    <span class="value-label">Depois:</span>
                    <span class="value-content" [innerHTML]="formatValue(change.valueAfter)"></span>
                  </div>
                </div>
              </div>
            </div>

            <div class="no-changes" *ngIf="!log.changes || log.changes.length === 0">
              <i class="pi pi-info-circle"></i>
              <span>Nenhuma alteração registrada</span>
            </div>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4" class="text-center">
          <div class="empty-message">
            <i class="pi pi-inbox"></i>
            <p>Nenhum log encontrado</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
